import { controlFlowModule } from "@/modules/control-flow";

export enum TanstackDatabaseStorageKind {
  LOCAL_MEMORY = "local_memory",
  TURSO_MEMORY = "turso_memory",
  TURSO_DB = "turso_db",
}

export type TanstackDatabaseStorageConfig =
  | {
      kind: TanstackDatabaseStorageKind.LOCAL_MEMORY;
    }
  | {
      kind: TanstackDatabaseStorageKind.TURSO_MEMORY;
    }
  | {
      kind: TanstackDatabaseStorageKind.TURSO_DB;
    };

const LOCAL_MEMORY_STORAGE: TanstackDatabaseStorageConfig = Object.freeze({
  kind: TanstackDatabaseStorageKind.LOCAL_MEMORY,
});

export const getDefaultTanstackStorage = (): TanstackDatabaseStorageConfig => LOCAL_MEMORY_STORAGE;

export const assertSupportedTanstackStorage = (storage: TanstackDatabaseStorageConfig): void => {
  if (storage.kind !== TanstackDatabaseStorageKind.LOCAL_MEMORY) {
    controlFlowModule.notImplementedError({
      message: `[TanstackDatabase] Storage kind "${storage.kind}" is not implemented yet.`,
    });
  }
};

export const tanstackStorageConfigsEqual = (
  lhs: TanstackDatabaseStorageConfig,
  rhs: TanstackDatabaseStorageConfig
): boolean => lhs.kind === rhs.kind;
